import React from "react";
import Goo from "../../ui-library/Goo/Goo";
import logo from "../../../assets/logo.png";
import styled from "styled-components";

const StyledContainer = styled.div`
  -webkit-animation: fadein 3s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 3s; /* Firefox < 16 */
  -ms-animation: fadein 3s; /* Internet Explorer */
  -o-animation: fadein 3s; /* Opera < 12.1 */
  animation: fadein 3s;
`;

const FullPageLoading = () => {
  return (
    <StyledContainer
      data-testid="full-page-loading"
      style={{
        width: "100vw",
        overflow: "hidden",
        height: "100vh",
        marginTop: "-75px",
      }}
      className="d-flex flex-column justify-content-center align-items-center w-100"
      id="full-page-loading"
    >
      <div style={{ zIndex: "100" }}>
        <img src={logo} alt="Logo" style={{ width: "25vw" }} />
      </div>
      <div style={{ zIndex: "100" }}>
        <span className="text-secondary me-2">Loading Rarify ...</span>
        <div className="spinner-border" role="status"></div>
      </div>
      <Goo
        style={{ zIndex: "50" }}
        center={[window.innerWidth / 2, window.innerHeight / 3]}
      />
    </StyledContainer>
  );
};

export default FullPageLoading;
